<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs">
	<div class="cards-holder">
		<div class="card card2 mRight" #chartcontainer>
			<!-- <app-loader [showLoader]=showLoad></app-loader> -->
			<div class="c-portlet__header">
				<div class="o-stack__cell">
					<h5 class="creative-charts-header creative-charts-header-with-download">{{ sectiontitle }}</h5>
					<span class="datatable-icon">
						<a
							href="javascript:void(0)"
							class="datatable_download_icon"
							(click)="downloadCSV($event)"
							target="_blank"
							*ngIf="downloadConfiguration.enableDownload"
						>
							<i class="fa fa-download" aria-hidden="true"></i>
						</a>
					</span>
				</div>
			</div>
			<div class="performance-graph-area">
				<select (change)="updateCampaign($event.target.value)">
					<option *ngFor="let campaign of displayData; let index = index" [value]="index">{{ campaign.name }}</option>
				</select>
				<div class="card3 preroll-creative-v3-carousel-cntr creative-performance-stats display-creative-container">
					<!-- <app-loader [showLoader]=showLoad></app-loader> -->
					<div class="analytics-portlet-Img100p display-preroll-carousel-height" *ngIf="hasData">
						<div
							class="
								c-portlet
								o-block
								u-width-100p
								_u-width-100p
								widget-grid
								u-shadow-mini u-bg-primary u-color-white-900
							"
						>
							<div class="c-portlet__content u-pt-small">
								<div class="o-stack o-stack center preroll-creative-img" id="videoDisplayblock">
									<div class="video-width">
										<div class="align-controls">
											<div
												class="ShowControls"
												[hidden]="setDisplayProperties.mp4 == '' && setDisplayProperties.audioURL == ''"
											>
												<svg
													*ngIf="isAudioCreative"
													class="audioCreativeSVG"
													width="100%"
													height="100%"
													viewBox="0 0 419 219"
													version="1.1"
													xmlns="http://www.w3.org/2000/svg"
													xmlns:xlink="http://www.w3.org/1999/xlink"
												>
													<title>Streaming Audio Icon</title>
													<defs>
														<filter
															x="-3.0%"
															y="-6.0%"
															width="106.0%"
															height="111.9%"
															filterUnits="objectBoundingBox"
															id="filter-1"
														>
															<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
															<feGaussianBlur
																stdDeviation="2"
																in="shadowOffsetOuter1"
																result="shadowBlurOuter1"
															></feGaussianBlur>
															<feColorMatrix
																values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
																type="matrix"
																in="shadowBlurOuter1"
																result="shadowMatrixOuter1"
															></feColorMatrix>
															<feMerge>
																<feMergeNode in="shadowMatrixOuter1"></feMergeNode>
																<feMergeNode in="SourceGraphic"></feMergeNode>
															</feMerge>
														</filter>
														<linearGradient
															x1="12.5386049%"
															y1="41.7874428%"
															x2="100%"
															y2="62.5%"
															id="linearGradient-2"
														>
															<stop stop-color="#175f79" offset="0%"></stop>
															<stop stop-color="#FFFFFF" offset="100%"></stop>
														</linearGradient>
														<path
															d="M135,92 C135.552285,92 136,92.4477153 136,93 L136,149 C136,149.552285 135.552285,150 135,150 L132,150 C131.447715,150 131,149.552285 131,149 L131,93 C131,92.4477153 131.447715,92 132,92 L135,92 Z M176,145 C176.552285,145 177,145.447715 177,146 L177,149 C177,149.552285 176.552285,150 176,150 L158,150 C157.447715,150 157,149.552285 157,149 L157,146 C157,145.447715 157.447715,145 158,145 L176,145 Z M201,145 C201.552285,145 202,145.447715 202,146 L202,149 C202,149.552285 201.552285,150 201,150 L183,150 C182.447715,150 182,149.552285 182,149 L182,146 C182,145.447715 182.447715,145 183,145 L201,145 Z M226,145 C226.552285,145 227,145.447715 227,146 L227,149 C227,149.552285 226.552285,150 226,150 L208,150 C207.447715,150 207,149.552285 207,149 L207,146 C207,145.447715 207.447715,145 208,145 L226,145 Z M251,145 C251.552285,145 252,145.447715 252,146 L252,149 C252,149.552285 251.552285,150 251,150 L233,150 C232.447715,150 232,149.552285 232,149 L232,146 C232,145.447715 232.447715,145 233,145 L251,145 Z M276,145 C276.552285,145 277,145.447715 277,146 L277,149 C277,149.552285 276.552285,150 276,150 L258,150 C257.447715,150 257,149.552285 257,149 L257,146 C257,145.447715 257.447715,145 258,145 L276,145 Z M301,145 C301.552285,145 302,145.447715 302,146 L302,149 C302,149.552285 301.552285,150 301,150 L283,150 C282.447715,150 282,149.552285 282,149 L282,146 C282,145.447715 282.447715,145 283,145 L301,145 Z M201,138 C201.552285,138 202,138.447715 202,139 L202,142 C202,142.552285 201.552285,143 201,143 L183,143 C182.447715,143 182,142.552285 182,142 L182,139 C182,138.447715 182.447715,138 183,138 L201,138 Z M226,138 C226.552285,138 227,138.447715 227,139 L227,142 C227,142.552285 226.552285,143 226,143 L208,143 C207.447715,143 207,142.552285 207,142 L207,139 C207,138.447715 207.447715,138 208,138 L226,138 Z M276,138 C276.552285,138 277,138.447715 277,139 L277,142 C277,142.552285 276.552285,143 276,143 L258,143 C257.447715,143 257,142.552285 257,142 L257,139 C257,138.447715 257.447715,138 258,138 L276,138 Z M301,138 C301.552285,138 302,138.447715 302,139 L302,142 C302,142.552285 301.552285,143 301,143 L283,143 C282.447715,143 282,142.552285 282,142 L282,139 C282,138.447715 282.447715,138 283,138 L301,138 Z M251,138 C251.552285,138 252,138.447715 252,139 L252,142 C252,142.552285 251.552285,143 251,143 L233,143 C232.447715,143 232,142.552285 232,142 L232,139 C232,138.447715 232.447715,138 233,138 L251,138 Z M201,131 C201.552285,131 202,131.447715 202,132 L202,135 C202,135.552285 201.552285,136 201,136 L183,136 C182.447715,136 182,135.552285 182,135 L182,132 C182,131.447715 182.447715,131 183,131 L201,131 Z M226,131 C226.552285,131 227,131.447715 227,132 L227,135 C227,135.552285 226.552285,136 226,136 L208,136 C207.447715,136 207,135.552285 207,135 L207,132 C207,131.447715 207.447715,131 208,131 L226,131 Z M276,131 C276.552285,131 277,131.447715 277,132 L277,135 C277,135.552285 276.552285,136 276,136 L258,136 C257.447715,136 257,135.552285 257,135 L257,132 C257,131.447715 257.447715,131 258,131 L276,131 Z M251,131 C251.552285,131 252,131.447715 252,132 L252,135 C252,135.552285 251.552285,136 251,136 L233,136 C232.447715,136 232,135.552285 232,135 L232,132 C232,131.447715 232.447715,131 233,131 L251,131 Z M201,124 C201.552285,124 202,124.447715 202,125 L202,128 C202,128.552285 201.552285,129 201,129 L183,129 C182.447715,129 182,128.552285 182,128 L182,125 C182,124.447715 182.447715,124 183,124 L201,124 Z M226,124 C226.552285,124 227,124.447715 227,125 L227,128 C227,128.552285 226.552285,129 226,129 L208,129 C207.447715,129 207,128.552285 207,128 L207,125 C207,124.447715 207.447715,124 208,124 L226,124 Z M276,124 C276.552285,124 277,124.447715 277,125 L277,128 C277,128.552285 276.552285,129 276,129 L258,129 C257.447715,129 257,128.552285 257,128 L257,125 C257,124.447715 257.447715,124 258,124 L276,124 Z M251,124 C251.552285,124 252,124.447715 252,125 L252,128 C252,128.552285 251.552285,129 251,129 L233,129 C232.447715,129 232,128.552285 232,128 L232,125 C232,124.447715 232.447715,124 233,124 L251,124 Z M108.015255,72.2870582 L110.843812,75.1153586 C105.069861,80.9039292 101.5,88.892056 101.5,97.7139686 C101.5,106.535376 105.069452,114.523094 110.842821,120.311585 L108.01441,123.140033 C101.517174,116.627681 97.5,107.639955 97.5,97.7139686 C97.5,87.7875519 101.517522,78.7994778 108.015255,72.2870582 Z M158.984745,72.2870582 C165.482478,78.7994778 169.5,87.7875519 169.5,97.7139686 C169.5,107.639955 165.482826,116.627681 158.98559,123.140033 L156.157179,120.311585 C161.930548,114.523094 165.5,106.535376 165.5,97.7139686 C165.5,88.892056 161.930139,80.9039292 156.156188,75.1153586 L158.984745,72.2870582 Z M226,117 C226.552285,117 227,117.447715 227,118 L227,121 C227,121.552285 226.552285,122 226,122 L208,122 C207.447715,122 207,121.552285 207,121 L207,118 C207,117.447715 207.447715,117 208,117 L226,117 Z M251,117 C251.552285,117 252,117.447715 252,118 L252,121 C252,121.552285 251.552285,122 251,122 L233,122 C232.447715,122 232,121.552285 232,121 L232,118 C232,117.447715 232.447715,117 233,117 L251,117 Z M113.672124,77.9439065 L116.500727,80.7721641 C112.174456,85.1130185 109.5,91.1011672 109.5,97.7139686 C109.5,104.326714 112.174411,110.314818 116.500618,114.655663 L113.672312,117.484219 C108.622176,112.419503 105.5,105.431347 105.5,97.7139686 C105.5,89.9966855 108.622099,83.0086077 113.672124,77.9439065 Z M153.327876,77.9439065 C158.377901,83.0086077 161.5,89.9966855 161.5,97.7139686 C161.5,105.430844 158.378231,112.418591 153.328677,117.483228 L150.500375,114.654667 C154.825998,110.313901 157.5,104.326208 157.5,97.7139686 C157.5,91.1011672 154.825544,85.1130185 150.499273,80.7721641 L153.327876,77.9439065 Z M251,110 C251.552285,110 252,110.447715 252,111 L252,114 C252,114.552285 251.552285,115 251,115 L233,115 C232.447715,115 232,114.552285 232,114 L232,111 C232,110.447715 232.447715,110 233,110 L251,110 Z M119.328995,83.6007608 L122.156644,86.4299853 C119.278641,89.3230366 117.5,93.3107907 117.5,97.7139686 C117.5,102.11758 119.278991,106.105685 122.157493,108.998806 L119.329122,111.827303 C115.726728,108.210314 113.5,103.222181 113.5,97.7139686 C113.5,92.2058203 115.726676,87.2177401 119.328995,83.6007608 Z M147.671005,83.6007608 C151.273324,87.2177401 153.5,92.2058203 153.5,97.7139686 C153.5,103.222181 151.273272,108.210314 147.670878,111.827303 L144.842507,108.998806 C147.721009,106.105685 149.5,102.11758 149.5,97.7139686 C149.5,93.3107907 147.721359,89.3230366 144.843356,86.4299853 L147.671005,83.6007608 Z M124.5,94.3615898 C124.587013,94.3615898 124.672521,94.3842975 124.748069,94.4274683 L130.240287,97.5658784 C130.480046,97.7028834 130.563344,98.0083107 130.426339,98.2480695 C130.382045,98.3255851 130.317803,98.3898269 130.240287,98.4341216 L124.748069,101.572532 C124.508311,101.709537 124.202883,101.626238 124.065878,101.38648 C124.022708,101.310931 124,101.225424 124,101.13841 L124,94.8615898 C124,94.5854475 124.223858,94.3615898 124.5,94.3615898 Z M142.934122,94.6135204 C142.977292,94.6890692 143,94.7745764 143,94.8615898 L143,101.13841 C143,101.414553 142.776142,101.63841 142.5,101.63841 C142.412987,101.63841 142.327479,101.615703 142.251931,101.572532 L136.759713,98.4341216 C136.519954,98.2971166 136.436656,97.9916893 136.573661,97.7519305 C136.617955,97.6744149 136.682197,97.6101731 136.759713,97.5658784 L142.251931,94.4274683 C142.491689,94.2904633 142.797117,94.3737616 142.934122,94.6135204 Z"
															id="path-3"
														></path>
														<filter
															x="-2.7%"
															y="-4.5%"
															width="105.4%"
															height="114.2%"
															filterUnits="objectBoundingBox"
															id="filter-4"
														>
															<feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
															<feGaussianBlur
																stdDeviation="1.5"
																in="shadowOffsetOuter1"
																result="shadowBlurOuter1"
															></feGaussianBlur>
															<feColorMatrix
																values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 0.25 0"
																type="matrix"
																in="shadowBlurOuter1"
															></feColorMatrix>
														</filter>
													</defs>
													<g id="Social-Demographics" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
														<g id="Group-9" filter="url(#filter-1)" transform="translate(9.000000, 9.000000)">
															<rect
																id="Rectangle"
																fill="url(#linearGradient-2)"
																x="-10"
																y="-20"
																width="420"
																height="235"
															></rect>
															<path
																d="M26.1708635,200.002966 L23.9851501,200.001954 C14.4976761,189.869535 6.40008568,178.419673 -0.00353297835,165.956455 L-0.00470623086,162.406325 C6.75699508,176.288476 15.6201577,188.958662 26.1708635,200.002966 Z M6.67073171,97.5 C6.67073171,139.614638 27.1975876,176.934971 58.7922019,200.001903 L53.5296795,200.00004 C23.0773277,176.207426 3.5,139.139978 3.5,97.5 C3.5,58.671925 20.5225317,23.8196754 47.5118912,-0.00104508165 L52.3831805,-0.00149237639 C24.4498268,23.2632507 6.67073171,58.3053603 6.67073171,97.5 Z M23.4530201,98 C23.4530201,143.919902 51.4512652,183.300464 91.3079398,200.001869 L73.6500118,200.002573 C38.8377725,179.361415 15.5,141.406122 15.5,98 C15.5,57.262296 36.0565643,21.3258348 67.3625521,-0.00224254269 L82.80418,-0.00315047661 C47.5259126,18.4636961 23.4530201,55.4205854 23.4530201,98 Z M252.5,98 C252.5,141.406256 229.162083,179.36165 194.349665,200.002765 L176.692846,200.00154 C216.549103,183.299946 244.54698,143.9196 244.54698,98 C244.54698,55.4206897 220.474205,18.4638772 185.196079,-0.00301471629 L200.637448,-0.00224254269 C231.943436,21.3258348 252.5,57.262296 252.5,98 Z M263.5,97.5 C263.5,139.139978 243.922672,176.207426 213.470321,200.00004 L208.207674,200.001993 C239.802359,176.935069 260.329268,139.614693 260.329268,97.5 C260.329268,58.3053811 242.550192,23.263288 214.616864,-0.001455221 L219.488109,-0.00104508165 C246.477468,23.8196754 263.5,58.671925 263.5,97.5 Z M283.5,97.5 C283.5,137.137542 268.125608,173.184202 243.01485,200.001954 L240.829136,200.002966 C266.281226,173.360141 281.912698,137.255533 281.912698,97.5 C281.912698,60.1791976 268.137221,26.0758303 245.393555,-0.00281226854 L247.492867,-0.0010722459 C269.941142,26.2194842 283.5,60.2763217 283.5,97.5 Z M349.5,97.5 C349.5,134.593728 340.149755,169.503588 323.677615,200.001232 L320.057843,200.003057 C336.798972,169.598608 346.323529,134.661594 346.323529,97.5 C346.323529,62.3597389 337.806932,29.2086357 322.725222,-0.00182503475 L326.293077,-0.00336905781 C341.135933,29.2873702 349.5,62.4169189 349.5,97.5 Z M400.007375,192.9278 L400,200 L397.366415,200.001531 C398.277201,197.658593 399.157681,195.300522 400.007375,192.9278 Z M133.5,24 C174.092929,24 207,56.9070709 207,97.5 C207,138.092929 174.092929,171 133.5,171 C92.9070709,171 60,138.092929 60,97.5 C60,56.9070709 92.9070709,24 133.5,24 Z M133.5,34 C98.4299184,34 70,62.4299184 70,97.5 C70,132.570082 98.4299184,161 133.5,161 C168.570082,161 197,132.570082 197,97.5 C197,62.4299184 168.570082,34 133.5,34 Z M133.5,52 C158.628956,52 179,72.3710439 179,97.5 C179,122.628956 158.628956,143 133.5,143 C108.371044,143 88,122.628956 88,97.5 C88,72.3710439 108.371044,52 133.5,52 Z M-0.00451282515,32.5932777 L-0.00313874031,29.0427774 C5.3682619,18.5886909 11.9315062,8.84758715 19.5071326,-0.0010722459 L21.6064455,-0.00281226854 C13.0472511,9.81144412 5.7581908,20.762215 -0.00451282515,32.5932777 Z M400,-1.42108547e-14 L400.007223,2.07177558 C399.759246,1.37931852 399.508648,0.688109376 399.255439,-0.00183988471 L400,-1.42108547e-14 Z"
																id="Combined-Shape"
																fill-opacity="0.07"
																fill="#FFFFFF"
															></path>
															<g id="Combined-Shape">
																<use fill="black" fill-opacity="1" filter="url(#filter-4)" xlink:href="#path-3"></use>
																<use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#path-3"></use>
															</g>
															<path
																d="M195.351071,68.7841846 L195.607005,69.7363762 L198.806182,81.6387702 C199.018205,82.4275916 198.014075,83.381189 196.563395,83.7686912 C195.112715,84.1561904 193.764828,83.8308558 193.552805,83.0420346 C193.340783,82.2532132 194.344913,81.2996158 195.795592,80.9121136 C196.225669,80.7972334 196.646712,80.7450055 197.031801,80.7489327 L194.481437,71.2651846 L187.119437,74.3451846 L190.116069,85.4908776 C190.318873,86.2454023 189.408978,87.1506863 188.059906,87.5671045 L187.873282,87.6207985 C186.422602,88.0082978 185.074715,87.6829632 184.862692,86.8941419 C184.650669,86.1053206 185.654799,85.1517232 187.105479,84.764221 C187.535489,84.6493587 187.956467,84.5971291 188.341507,84.6010382 L185.228218,73.0190004 L195.351071,68.7841846 Z M226.084361,61.7841846 L233.834437,62.3108638 L233.046037,65.4112932 L227.620437,65.0421846 L222.969421,83.3351512 C222.65374,84.5765831 220.703245,85.1129027 218.555241,84.5774152 L218.332388,84.5181816 C216.097992,83.8873113 214.55139,82.3348078 214.877957,81.0505679 C215.204523,79.766328 217.280593,79.2366673 219.514989,79.8675375 C220.177647,80.0546356 220.77981,80.3227956 221.290559,80.6409792 L226.084361,61.7841846 Z M263.949291,45.0441455 L288.779368,48.3130828 L288.208506,50.4718287 L281.072747,77.4561549 C280.59982,79.244516 277.533088,79.9659441 274.222983,79.0675668 C270.91291,78.1690702 268.612928,75.990988 269.085836,74.2026217 C269.558762,72.4142606 272.625495,71.6928325 275.9356,72.5912099 C276.916362,72.8574311 277.808447,73.235989 278.566,73.6834614 L284.251421,52.1836695 L266.192945,49.8058666 L259.511823,75.0745435 C259.051678,76.8145705 256.136038,77.5445572 252.929866,76.755258 L252.662059,76.6859553 C249.351986,75.7874588 247.052004,73.6093765 247.524911,71.8210103 C247.997838,70.0326492 251.064571,69.3112211 254.374675,70.2095984 C255.355794,70.4759163 256.24817,70.8546524 257.005901,71.3023372 L263.949291,45.0441455 Z"
																id="Combined-Shape"
																fill="#175f79"
															></path>
														</g>
													</g>
												</svg>

												<video
													class=""
													(click)="controlsOptions()"
													id="preRollvideo"
													autoplay
													#videoName
													[src]="isAudioCreative ? setDisplayProperties.audioURL : setDisplayProperties.mp4"
												>
													<source type="video/mp4" />
													Your browser does not support HTML5 video.
												</video>
												<div class="showIconsControls">
													<span class="playVideo" (click)="playclickEvent()">
														<img id="playBtn" class="volumeClass" src="./assets/images/play.png" />
													</span>
													<span class="playVideo" (click)="pauseclickEvent()">
														<img id="pauseBtn" class="volumeClass" src="./assets/images/pause.png" />
													</span>
												</div>
											</div>
											<div class="volumecontrols">
												<span id="volumeBtn" class="volumeControlIcon" (click)="volumeclick()">
													<!--<i class="volumecontrols fa fa-volume-up"></i>-->
													<span class="VolumeControlHoverClass">&nbsp;&nbsp;&nbsp;MUTE&nbsp;&nbsp;&nbsp;</span>
													<img id="volumebtn" class="volumeClass" src="./assets/images/muteicon.png" />
												</span>
												<span id="muteBtn" class="volumeControlIcon" (click)="muteclick()">
													<!--<i class="volumecontrols fa fa-volume-off"></i>-->
													<span class="VolumeControlHoverClass">UNMUTE</span>
													<img id="mutebtn" class="volumeClass" src="./assets/images/unmuteicon.png" />
												</span>
											</div>
										</div>
										<div *ngIf="!isAudioCreative">
											<div class="preRoll-creative-stats creative-stats">
												<div class="metrics-div">
													<div class="stats preRoll-creative-header-content">
														{{ setDisplayProperties.impressions | formatNumber }}
													</div>
													<div class="stats-label preRoll-creative-views">IMPRESSIONS</div>
												</div>
												<div class="metrics-div">
													<div class="stats preRoll-creative-header-content">
														{{ setDisplayProperties.percent_value_100 | formatNumber }}
													</div>
													<div class="stats-label preRoll-creative-views">COMPLETIONS</div>
												</div>
												<div class="metrics-div">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.completion_rate | formatNumber }}%</span
													>
													<span class="stats-label preRoll-creative-views">COMPLETION RATE</span>
												</div>
												<div class="metrics-div">
													<span class="stats preRoll-creative-header-content">{{
														setDisplayProperties.clicks | formatNumber
													}}</span>
													<span class="stats-label preRoll-creative-views">CLICKS</span>
												</div>
												<div class="metrics-div">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.click_rate }}%</span
													>
													<span class="stats-label preRoll-creative-views">CLICK RATE</span>
												</div>

												<div class="metrics-div" *ngIf="youtubeViewsPermission && isPreroll">
													<span class="stats preRoll-creative-header-content">{{
														setDisplayProperties.youtube_verified_imprs | formatNumber
													}}</span>
													<span class="stats-label preRoll-creative-views">YOUTUBE VIEWS</span>
												</div>
												<div class="metrics-div" *ngIf="youtubeViewsPermission && isPreroll">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.youtube_verified_imprs_rate }}%</span
													>
													<span class="stats-label preRoll-creative-views">YOUTUBE VIEW RATE</span>
												</div>
											</div>
										</div>
										<div *ngIf="isAudioCreative">
											<div class="preRoll-creative-stats creative-stats">
												<div class="metrics-div">
													<div class="stats preRoll-creative-header-content">
														{{ setDisplayProperties.impressions | formatNumber }}
													</div>
													<div class="stats-label preRoll-creative-views">IMPRESSIONS</div>
												</div>
												<div class="metrics-div">
													<div class="stats preRoll-creative-header-content">
														{{ setDisplayProperties.percent_value_100 | formatNumber }}
													</div>
													<div class="stats-label preRoll-creative-views">COMPLETIONS</div>
												</div>
												<div class="metrics-div">
													<span class="stats preRoll-creative-header-content"
														>{{ setDisplayProperties.completion_rate | formatNumber }}%</span
													>
													<span class="stats-label preRoll-creative-views">COMPLETION RATE</span>
												</div>
											</div>
										</div>
									</div>
									<div class="r4-mRight">
										<div class="mRight creative-performance-stats detail-colors">
											<!-- <app-loader [showLoader]=showLoad></app-loader> -->
											<div class="preRoll-creative-completion-stats-container">
												<div
													class="preRoll-creative-completion-stats-scroll-div"
													*ngIf="hasData && overallCompletionData && !isAudioCreative"
												>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent0"
														(click)="circleVideoClickEvent(0)"
													>
														<div class="progressbar">
															<div class="primary-color-bg progressbar-primary-color-bg"></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">Started</span
															><span class="par-val primary-color"
																>100% | {{ setDisplayProperties.impressions | formatNumber }} Views</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent25"
														(click)="circleVideoClickEvent(25)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.quarter)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">25% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_25 }}% |
																{{ setDisplayProperties.percent_value_25 | formatNumber }} Views</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent50"
														(click)="circleVideoClickEvent(50)"
													>
														<div class="progressbar">
															<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">50% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_50 }}% |
																{{ setDisplayProperties.percent_value_50 | formatNumber }} Views</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent75"
														(click)="circleVideoClickEvent(75)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.threeQuarters)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">75% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_75 }}% |
																{{ setDisplayProperties.percent_value_75 | formatNumber }} Views</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent100"
														(click)="circleVideoClickEvent(100)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.completed)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">100% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_100 }}% |
																{{ setDisplayProperties.percent_value_100 | formatNumber }} Views</span
															>
														</div>
													</div>
												</div>
												<div
													class="preRoll-creative-completion-stats-scroll-div"
													*ngIf="hasData && overallCompletionData && isAudioCreative"
												>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent0"
														(click)="circleVideoClickEvent(0)"
													>
														<div class="progressbar">
															<div class="primary-color-bg progressbar-primary-color-bg"></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">Started</span
															><span class="par-val primary-color"
																>100% | {{ setDisplayProperties.impressions | formatNumber }}</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent25"
														(click)="circleVideoClickEvent(25)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.quarter)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">25% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_25 }}% |
																{{ setDisplayProperties.percent_value_25 | formatNumber }}</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent50"
														(click)="circleVideoClickEvent(50)"
													>
														<div class="progressbar">
															<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">50% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_50 }}% |
																{{ setDisplayProperties.percent_value_50 | formatNumber }}</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent75"
														(click)="circleVideoClickEvent(75)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.threeQuarters)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">75% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_75 }}% |
																{{ setDisplayProperties.percent_value_75 | formatNumber }}</span
															>
														</div>
													</div>
													<div
														class="preRoll-creative-completion-stats creative_text_mask"
														id="percent100"
														(click)="circleVideoClickEvent(100)"
													>
														<div class="progressbar">
															<div
																class="primary-color-bg"
																[ngStyle]="getPercentage(overallCompletionData.completed)"
															></div>
														</div>
														<div class="preRoll-creative-views par-title-font add-color">
															<span class="par-title">100% Completed</span
															><span class="par-val primary-color"
																>{{ setDisplayProperties.percent_rate_100 }}% |
																{{ setDisplayProperties.percent_value_100 | formatNumber }}</span
															>
														</div>
													</div>
												</div>
												<div class="no-data-container" *ngIf="!hasData">
													<div class="map-no-data">No Data to Display</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="no-data-container" *ngIf="!hasData">
						<app-loader [showLoader]="showLoad" *ngIf="showLoad"></app-loader>
						<div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
					</div>
					<!-- </div> -->
				</div>
			</div>
		</div>
		<div class="card card1 mLeft lift-right right-card">
			<app-loader [showLoader]="showLoad"></app-loader>
			<div class="c-portlet__header">
				<div class="o-stack__cell">
					<h5>Overall Completion Rates</h5>
				</div>
			</div>
			<div class="y-scroll-area">
				<div class="mRight creative-performance-stats detail-colors">
					<div class="preRoll-creative-completion-stats-container">
						<div
							class="preRoll-creative-completion-stats-scroll-div"
							*ngIf="hasData && overallCompletionData && !isAudioCreative"
						>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg progressbar-primary-color-bg"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">Started</span
									><span class="par-val primary-color"
										>100% | {{ overallCompletionData.startedValue | formatNumber }} Views</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.quarter)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">25% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.quarter }}% |
										{{ overallCompletionData.quarterValue | formatNumber }} Views</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">50% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.half }}% |
										{{ overallCompletionData.halfValue | formatNumber }} Views</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.threeQuarters)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">75% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.threeQuarters }}% |
										{{ overallCompletionData.threeQuartersValue | formatNumber }} Views</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.completed)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">100% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.completed }}% |
										{{ overallCompletionData.completionValue | formatNumber }} Views</span
									>
								</div>
							</div>
						</div>
						<div
							class="preRoll-creative-completion-stats-scroll-div"
							*ngIf="hasData && overallCompletionData && isAudioCreative"
						>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg progressbar-primary-color-bg"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">Started</span
									><span class="par-val primary-color"
										>100% | {{ overallCompletionData.startedValue | formatNumber }}</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.quarter)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">25% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.quarter }}% |
										{{ overallCompletionData.quarterValue | formatNumber }}</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.half)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">50% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.half }}% | {{ overallCompletionData.halfValue | formatNumber }}</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.threeQuarters)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">75% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.threeQuarters }}% |
										{{ overallCompletionData.threeQuartersValue | formatNumber }}</span
									>
								</div>
							</div>
							<div class="preRoll-creative-completion-stats">
								<div class="progressbar">
									<div class="primary-color-bg" [ngStyle]="getPercentage(overallCompletionData.completed)"></div>
								</div>
								<div class="preRoll-creative-views par-title-font add-color">
									<span class="par-title">100% Completed</span
									><span class="par-val primary-color"
										>{{ overallCompletionData.completed }}% |
										{{ overallCompletionData.completionValue | formatNumber }}</span
									>
								</div>
							</div>
						</div>
						<div class="no-data-container" *ngIf="!hasData">
							<div class="map-no-data">No Data to Display</div>
						</div>
					</div>
				</div>
			</div>
			<div class="no-data-container" *ngIf="!hasData">
				<app-loader [showLoader]="showLoad" *ngIf="showLoad"></app-loader>
				<div class="map-no-data" *ngIf="!showLoad">No Data to Display</div>
			</div>
		</div>
	</div>
</div>
